import { ListItemBox } from "lib/@components/ListItemBox"
import { Box, CircularProgress, FormControlLabel, Radio, RadioGroup, Stack, Tooltip, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { setAnswer } from "routes/asset-register/plugins/asset-mapping/controller/set-answer"
import { If } from "lib/@components/switch"
import { useDisabledUntilInvalidation } from "lib/@hooks/use-disabled-until-invalidation"

export function Question({ item: { question, answer } }) {
    const [mainQuestion, extra] = question.split("?")
    const { register, assetType, isManualMapTab } = useBoundContext()
    const [disabled, disable] = useDisabledUntilInvalidation("typeFromRegister")
    const disableSelection = disabled || isManualMapTab

    return (
        <Stack sx={{ maxWidth: 700, pb: 1 }}>
            <Tooltip title={extra} arrow>
                <ListItemBox spacing={1} alignItems="flex-start">
                    <Box alignSelf="flex-start" pr={1}>
                        <Iconify
                            icon="fluent:chat-bubbles-question-20-filled"
                            sx={{ color: "primary.main", fontSize: 24 }}
                        />
                    </Box>

                    <Box flex={1} pr={2}>
                        <Stack>
                            <Typography data-cy="ai-mapping-question" variant="body2">
                                {mainQuestion}?
                            </Typography>
                        </Stack>
                    </Box>
                    <Box pt={0.5} width={8}>
                        <If truthy={disabled && !isManualMapTab}>
                            <CircularProgress size={16} />
                        </If>
                    </Box>
                    <Box>
                        <RadioGroup sx={{ mt: -0.8 }} row size="small" value={answer ?? ""} onChange={updateAnswer}>
                            <FormControlLabel
                                disableTypography
                                sx={{
                                    margin: 0,
                                    flexGrow: 1,
                                    fontSize: 13,
                                    justifyContent: "center",
                                    borderRadius: 1,
                                }}
                                value="yes"
                                control={
                                    <Radio
                                        disabled={disableSelection}
                                        size="small"
                                        checked={answer === "yes"}
                                        data-cy="mapping-wizard-question-yes"
                                    />
                                }
                                label="Yes"
                                tabIndex={-1}
                            />
                            <FormControlLabel
                                sx={{
                                    margin: 0,
                                    fontSize: 13,
                                    flexGrow: 1,
                                    justifyContent: "center",
                                    borderRadius: 1,
                                }}
                                disableTypography
                                value="no"
                                control={
                                    <Radio
                                        disabled={disableSelection}
                                        size="small"
                                        checked={answer === "no"}
                                        data-cy="mapping-wizard-question-no"
                                    />
                                }
                                label="No"
                                tabIndex={-1}
                            />
                            <FormControlLabel
                                disableTypography
                                sx={{
                                    margin: 0,
                                    fontSize: 13,
                                    flexGrow: 1,
                                    justifyContent: "center",
                                    borderRadius: 1,
                                }}
                                value=""
                                control={
                                    <Radio
                                        disabled={disableSelection}
                                        size="small"
                                        checked={!answer}
                                        data-cy="mapping-wizard-question-unknown"
                                    />
                                }
                                label="Don't Know"
                                tabIndex={-1}
                            />
                        </RadioGroup>
                    </Box>
                </ListItemBox>
            </Tooltip>
        </Stack>
    )

    async function updateAnswer(_, answer) {
        if (isManualMapTab) return
        disable()
        await setAnswer(register.id, assetType.name, question, answer)
    }
}
